export const UID = 'UID';
export const ERROR_STATE = 'ERROR_STATE';
export const IS_AUTH = 'IS_AUTH';
export const MENUS = 'MENUS';
export const LOCALE = 'LOCALE';
export const PARAMS = 'PARAMS';
export const AUTH_INFO = 'AUTH_INFO';
export const HIGHEST_ROLE = 'HIGHEST_ROLE';
export const API_ERROR_CODE = 'API_ERROR_CODE';
export const LOGOUT_CALLED = 'LOGOUT_CALLED';



// WEBPACK FOOTER //
// ./src/vuex/mutation_types.js